export const memberOrderCn = {
    dingdangliebiao: "订单列表",
    xiadangshijian:"起始下单时间",
    jieshushijian:'结束时间',
    shurudingdanghao:'请输入订单号',
    shurufuwumingcheng:'请输入服务名称',
    shoushuo:'搜索',
    zhuantai:'状态',
    caozuo:'操作',
    dingdangneirong:'订单内容',
    jiage:'价格',
    dingdh:'订单号',
    xiadh:'下单时间',
    zfdd:'支付订单',
    qxdd:'取消订单',
    ypjs:'样品寄送',
    ckxq:'查看详情',
    ddpj:'订单评价',
    ddzp:'订单追评',
    ckzp:'查看证书',
    xzbg:'下载报告',
    sqdd:'申请订单',
    spqxdd:'是否取消该订单',
    ddbh:'订单编号：',
    fahuoren:'发货人：',
    qsrxgnr:'请输入相关内容',
    fahuorendh:'发货人电话：',
    fahuorendz:'发货人地址：',
    qxzs:'请选择省',
    zxzshi:'请选择市',
    qxzq:'请选择区',
    fahuorxxdz:'发货人详细地址：',
    qingsrxxdz:'请输入详细地址',
    shouhuor:'收货人：',
    zsrshr:'请输入收货人',
    shrdh:'收货人电话：',
    qsrlxdh:'请输入联系电话',
    shrdz:'收货人地址：',
    shrxxdz:'收货人详细地址：',
    wllx:'物流类型：',
    qxzwllx:'请选择物流类型',
    wlbh:'物流编号：',
    qsrwlbh:'请输入物流编号',
    ypmc:'样品名称：',
    qsrypmc:'请输入样品名称',
    ypsl:'样品数量：',
    qsrypsl:'请输入样品数量',
    ypcl:'样品处理：',
    huishou:'回收',
    xiaohui:"销毁",
    beizhu:'备注：',
    qsrbez:'请输入备注',
    ddje:'订单金额：',
    fqqs:'分期期数：',
    qi:'期',
    zfje:'支付金额：',
    dqzfje:'当前支付金额：',
    fuwuxq:'服务详情',
    dingdh:'订单号：',
    xiadangsj:'下单时间：',
    fuwulx:'服务类型：',
    biaozfu:'标准服务',
    feibzfw:'非标准服务',
    dingdze:'订单总额：',
    kehuzh:'客户账号：',
    dingdzh:'订单状态：',
    fuwumingc:'服务名称',
    dangjia:'单价',
    shuliang:'数量',
    heji:'合计',
    beizhu:'备注：',
    shengqrxx:'申请人信息',
    xingming:'姓名：',
    lianxdh:'联系电话：',
    qiyexinxi:'企业信息',
    gongsimc:'公司名称：',
    gsdizhi:'公司地址：',
    zhifuxinxi:'支付信息',
    fukfs:'付款方式：',
    zhifubao:'支付宝',
    weixin:'微信',
    yinglian:'银联',
    tonglian:'通联',
    xcxzf:'小程序支付',
    xcxxxzf:'小程序线下支付',
    xianxia:'线下',
    fukuansj:'付款时间',
    yingfuze:'应支付金额',
    youhuiquan:'优惠券：',
    dingdangyouhui:'订单优惠：',
    baogaoxinxi:'报告信息',
    baogaoxinsi:'报告形式：',
    baogaoxinxi:'报告信息：',
    baogaotaitou:'报告抬头：',
    baogaoyoujidz:'报告邮寄地址',
    lianxiren:'联系人：',
    dianhua:'电话：',
    youxiang:'邮箱：',
    xiangxidz:'详细地址：',
    fankuixinxi:'反馈信息',
    fanhuiddlb:'返回订单列表',
    jichuxinxi:'基本信息',
    shengqingbiao:'申请表',
    tijiaodd:'提交订单',
    txsqb:'填写申请表',
    zhifu:'支付',
    fuwuzhong:'服务中',
    xiazaibaogao:'下载报告/评价',
    fuwuxinxi:'服务信息',
    jianchexinxi:'检测信息',
    qitazhiliao:'其他资料',
    jiachixx:'检测指南：',
    baogaobianhao:'报告编号：',
    shangcz:'上传者：',
    shangcrx:'上传日期：',
    youxiaoqi:'有效期：',
    zhengshumingc:'证书名称：',
    baogzxx:'报告总信息',
    fujianxiazai:'附件下载',
    quanbuxz:'全部下载',
    fanhuizsgl:'返回证书管理',
    zhengsdy:'证书打印',
    daochupdf:'导出PDF文件',
    xiangshang:'线上支付',
    xiangxia:'线下支付',
    zhifufangshi:'支付方式',
    fukuandanbianhao:'付款单编号',
    fukuanleixing:'付款类型',
    xiangshang1:'线上',
    zhuantai:'状态',
    fankuiyijian:'反馈意见',
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/memberOrder/memberOrderCn.js